export const RECOMMENDATION_SEVERITY = {
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
} as const;

export type RecommendationSeverity =
  (typeof RECOMMENDATION_SEVERITY)[keyof typeof RECOMMENDATION_SEVERITY];

export const SEVERITY_WEIGHT: Record<RecommendationSeverity, number> = {
  [RECOMMENDATION_SEVERITY.ERROR]: 3,
  [RECOMMENDATION_SEVERITY.WARNING]: 2,
  [RECOMMENDATION_SEVERITY.INFO]: 1,
};

export const RECOMMENDATION_CATEGORY = {
  GOVERNANCE: 'governance',
  SECURITY: 'security',
  OPERATIONS: 'operations',
} as const;

export type RecommendationCategory =
  (typeof RECOMMENDATION_CATEGORY)[keyof typeof RECOMMENDATION_CATEGORY];

export const CATEGORY_LABELS: Record<RecommendationCategory, string> = {
  [RECOMMENDATION_CATEGORY.GOVERNANCE]: 'Governance',
  [RECOMMENDATION_CATEGORY.SECURITY]: 'Security',
  [RECOMMENDATION_CATEGORY.OPERATIONS]: 'Operations',
};

export interface Recommendation {
  typeId: string;
  category: RecommendationCategory;
  severity: RecommendationSeverity;
  title: string;
  description: string;
  actionUrl: string;
  actionLabel: string;
}

export interface SeverityCounts {
  error: number;
  warning: number;
  info: number;
}

export interface RecommendationSummary {
  total: number;
  totalTypes: number;
  severityCounts: SeverityCounts;
  categoryCounts: Record<string, number>;
}
